// 根据Math的random函数生成的随机数截取m位，生成的随机数最大不超过16位，能保证首位不为0
export default function random(m: number): string {
  m = m > 16 ? 16 : m
  const num = Math.random().toString()
  if (num.substr(num.length - m, 1) === '0') {
    return random(m)
  }
  return num.substring(num.length - m)
}
